import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebase';
import { signInWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth';

const AdminLoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const navigate = useNavigate();

  // Remove o preloader quando o componente é montado
  useEffect(() => {
    const preloader = document.getElementById('preloader');
    if (preloader) {
      preloader.style.display = 'none';
    }
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setMessage('');
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate('/dashboard');
    } catch (err) {
      setMessage('Falha no login. Verifique seu e-mail e senha.');
      setMessageType('error');
      console.error(err);
    }
  };

  const handlePasswordReset = async () => {
    if (!email) {
      setMessage('Por favor, digite seu e-mail para redefinir a senha.');
      setMessageType('error');
      return;
    }

    try {
      await sendPasswordResetEmail(auth, email);
      setMessage('E-mail de redefinição enviado! Verifique sua caixa de entrada.');
      setMessageType('success');
    } catch (err) {
      setMessage('Erro ao enviar e-mail. Verifique se o e-mail está correto.');
      setMessageType('error');
      console.error(err);
    }
  };

  const backgroundImageUrl = "/loginhulk.png"; // Caminho para a imagem na pasta public

  return (
    <div 
      className="min-h-screen flex items-center justify-center bg-cover bg-center p-4 relative"
      style={{ backgroundImage: `url(${backgroundImageUrl})` }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/60"></div>

      {/* Glassmorphism Container */}
      <div className="w-full max-w-md bg-black/30 backdrop-blur-xl border border-white/10 rounded-2xl shadow-2xl p-8 text-white relative z-10">
        
        <h1 className="text-3xl font-bold text-center mb-2">Área Restrita</h1>
        <p className="text-center text-white/70 mb-6">Acesso exclusivo para o administrador.</p>
        
        {message && (
          <div className={`p-3 rounded-lg mb-4 text-center text-sm ${
            messageType === 'error' ? 'bg-red-500/20 text-red-300' : 'bg-green-500/20 text-green-300'
          }`}>
            {message}
          </div>
        )}

        <form onSubmit={handleLogin} className="space-y-6">
          <div>
            <label className="block text-white/80 mb-2" htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full p-3 bg-white/10 border border-white/20 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary transition-all"
              required
            />
          </div>
          <div>
            <label className="block text-white/80 mb-2" htmlFor="password">Senha</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full p-3 bg-white/10 border border-white/20 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary transition-all"
              required
            />
          </div>

          <div className="text-right">
            <button 
              type="button" 
              onClick={handlePasswordReset}
              className="text-sm text-white/70 hover:text-white transition-colors"
            >
              Esqueceu a senha?
            </button>
          </div>

          <button type="submit" className="w-full bg-button text-button-text font-bold py-3 rounded-lg hover:opacity-90 transition-opacity transform hover:scale-105">
            Entrar
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLoginPage;
